import * as React from 'react';
import { Button } from '@fluentui/react-components';
import { ChevronDown20Regular, ChevronRight20Regular } from '@fluentui/react-icons';

type Props = {
  isOpen: boolean;
  onClick: () => void;
  ariaLabel?: string;
  ariaControls?: string;
};

export default function ExpandToggle({ isOpen, onClick, ariaLabel, ariaControls }: Props) {
  return (
    <div
      style={{
        width: 28,
        height: 28,
        border: '1px solid #D6D6D6',
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
      }}
    >
      <Button
        appearance="transparent"
        icon={isOpen ? <ChevronDown20Regular /> : <ChevronRight20Regular />}
        onClick={onClick}
        style={{ minWidth: 0, padding: 0, height: 24, width: 24 }}
        aria-label={ariaLabel}
        title={ariaLabel}
        aria-expanded={isOpen}
        aria-controls={ariaControls}
      />
    </div>
  );
}
